// Facebook Pixel tracking helpers
// https://developers.facebook.com/docs/meta-pixel/reference

declare global {
  interface Window {
    fbq?: (action: string, event: string, params?: Record<string, unknown>) => void;
  }
}

type LeadSource = 'contact-page' | 'landing-weby' | 'landing-eshopy' | 'web-bez-rizika' | 'message-button';

interface TrackLeadParams {
  source: LeadSource;
  name?: string;
  email?: string;
  budget?: string;
  value?: number;
}

const SOURCE_LABELS: Record<LeadSource, string> = {
  'contact-page': 'Kontaktní stránka',
  'landing-weby': 'Landing - Weby na míru',
  'landing-eshopy': 'Landing - E-shopy na míru',
  'web-bez-rizika': 'Landing - Web bez rizika (FB Ads)',
  'message-button': 'Plovoucí chat',
};

export function trackLead(params: TrackLeadParams) {
  if (typeof window === 'undefined' || !window.fbq) return;

  const { source, budget, value = 1 } = params;

  // Standard Lead event - used by FB Pixel for optimization
  window.fbq('track', 'Lead', {
    content_name: SOURCE_LABELS[source],
    content_category: source,
    value,
    currency: 'CZK',
    ...(budget && { budget }),
  });

  // Custom event with source for granular reporting in Ads Manager
  window.fbq('trackCustom', 'FormSubmission', {
    source,
    source_label: SOURCE_LABELS[source],
    ...(budget && { budget }),
  });
}

export function trackContact() {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'Contact');
}

export function trackViewContent(contentName: string, category?: string) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'ViewContent', {
    content_name: contentName,
    ...(category && { content_category: category }),
  });
}
